import TableSys from "../generic/TableSys";
import TableSysLogs from "../generic/TableSysLogs";

export default function TableLogs({dados}) {


  const headCells = [
    { id: "syncDate", numeric: false, label: "Data", order: 1 },
    { id: "msg", numeric: false, label: "Mensagem", order: 2 },
    { id: "statusLog", numeric: false, label: "Status", order: 3 },
    { id: "typeSync" ,numeric:false,label: "Tipo",order: 4},
    { id: "user", numeric: false, label: "Usuário", order: 5 },

  ];
 

  return <TableSysLogs  idPage={1} header={headCells} dados={dados} ></TableSysLogs>;
}

